import { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
  TablePagination,
} from "@mui/material";
import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import "./EmailLogsReport.css";

export default function EmailLogsReport() {
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [status, setStatus] = useState("all");
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);


// const API_URL = "http://192.168.1.17:8000";
 const token = localStorage.getItem("accessToken");

// If this is your fixed project key
const API_URL = process.env.REACT_APP_API_URL;
const projectKey = process.env.REACT_APP_PROJECT_KEY;


  // Filter by Status
  useEffect(() => {
    if (status === "all") {
      setFilteredLogs(logs);
    } else {
      setFilteredLogs(
        logs.filter((log) => log.status === status)
      );
    }
  }, [status, logs]);

  // CSV Export
  const handleExportCSV = () => {
    const headers = [
      "Sr No",
      "Recipient Tracking Target",
      "Project Scope",
      "Channel Core",
      "Status Flag",
      "Dispatched At",
    ];

    const rows = filteredLogs.map((log, index) => [
  index + 1,
  log.recipient,
  log.project?.name,
  log.channel,
  log.status,
  log.created_at,
]);

    const csvContent = [
      headers,
      ...rows,
    ]
      .map((row) => row.join(","))
      .join("\n");

    const csv = "data:text/csv;charset=utf-8," + csvContent;

    const link = document.createElement("a");
    link.href = encodeURI(csv);
    link.download = "email_logs_report.csv";
    link.click();
  };

  // PDF Export
  const handleExportPDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.text("Email Logs Report", 14, 15);

    autoTable(doc, {
      startY: 25,
      head: [[
        "Sr No",
        "Recipient Tracking Target",
        "Project Scope",
        "Channel Core",
        "Status Flag",
        "Dispatched At",
      ]],
     body: filteredLogs.map((log, index) => [
  index + 1,
  log.recipient,
  log.project?.name,
  log.channel,
  log.status,
  log.created_at,
]),
    });

    doc.save("email_logs_report.pdf");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


 useEffect(() => {
  const fetchLogs = async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        `${API_URL}/api/pm/project-logs/`,
        {
          headers: {
            // Authorization: `Bearer ${token}`,
            "X-Project-Key": projectKey,
            Accept: "application/json",
          },
        }
      );

      const logsData = response.data.logs || [];

      setLogs(logsData);
      setFilteredLogs(logsData);
    } catch (error) {
      console.error("Error fetching logs:", error);

      if (error.response) {
        console.log(error.response.data);
      }
    }

    setLoading(false);
  };

  if (token && projectKey) {
    fetchLogs();
  }
}, [token, projectKey]);



  return (
    <Box className="report-container">
      {/* Top Bar */}
      <Box className="top-bar">
        <FormControl className="dropdown">
          <InputLabel>Status</InputLabel>

          <Select
            value={status}
            label="Status"
            onChange={(e) => setStatus(e.target.value)}
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="SENT">Sent</MenuItem>
            <MenuItem value="FAILED">Failed</MenuItem>
          </Select>
        </FormControl>

        <Box className="export-buttons">
          <Button
            className="btn-csv"
            onClick={handleExportCSV}
          >
            CSV
          </Button>

          <Button
            className="btn-pdf"
            onClick={handleExportPDF}
          >
            PDF
          </Button>
        </Box>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} className="table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sr No</TableCell>
              <TableCell>Recipient Tracking Target</TableCell>
              {/* <TableCell>Project Title</TableCell> */}
              <TableCell>Channel</TableCell>
              <TableCell>Status Flag</TableCell>
              <TableCell>Sent At</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : filteredLogs.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No Data
                </TableCell>
              </TableRow>
            ) : (
              filteredLogs
                .slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
                .map((log, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      {page * rowsPerPage + index + 1}
                    </TableCell>

                   <TableCell>{log.recipient}</TableCell>

{/* <TableCell>{log.project?.name}</TableCell> */}

<TableCell>{log.channel}</TableCell>

<TableCell>
  <span
    style={{
      color:
        log.status === "SUCCESS" ||
        log.status === "SENT"
          ? "green"
          : "red",
      fontWeight: "bold",
    }}
  >
    {log.status}
  </span>
</TableCell>

<TableCell>{log.created_at}</TableCell>
                  </TableRow>
                ))
            )}
          </TableBody>
        </Table>

       
      </TableContainer>
       <TablePagination
          rowsPerPageOptions={[10, 20, 35, 50]}
          component="div"
          count={filteredLogs.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
    </Box>
  );
}